import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Mascot } from '@/components/shared';

export default function NotFoundPage() {
  return (
    <div className="flex-1 overflow-auto">
      <div className="flex flex-col items-center justify-center min-h-[calc(100vh-3.5rem)] p-4 bg-background text-foreground">
        <div className="text-center">
          <Mascot variant="not-found" size="lg" className="mb-8" />
          <h1 className="text-4xl font-bold mb-4 text-foreground">404</h1>
          <p className="text-muted-foreground mb-6">Page not found</p>
          <Link to="/">
            <Button>
              Return to Dashboard
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
} 